import "./App.css";

import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import AllRoutes from "./Pages/AllRoutes";

function App() {
  return (
    <>

      <Navbar />
      <AllRoutes />
      <Footer />

    </>
  );
}

export default App;

